import * as Yup from 'yup';
import { discountValidationSchema } from './LineItemValidation';

const DiscountItemValidationSchema = Yup.object().shape({
  discounts: Yup.array().of(discountValidationSchema),
});

export { DiscountItemValidationSchema };
